import ApplicationController from './application_controller'

export default class extends ApplicationController {

	static targets = [
		'turboModal'
	]

	static values = {
		hidden: { type: Boolean, default: false },
	}

	connect() {
		this.getElement().addEventListener('shown.bs.modal', () => {
			const autofocusElement = this.getElement().querySelector('input[autofocus], select[autofocus], textarea[autofocus]')
			if (autofocusElement) { autofocusElement.focus() }
		})

		this.getElement().addEventListener('hidden.bs.modal', () => {
			document.body.classList.remove('modal-open')
			document.body.style.overflow = null
			document.body.style.paddingRight = null
		})

		if (this.hiddenValue == false) { this.openModal() }
	}	

	disconnect() {
		this.getModalInstance().dispose()
		document.body.classList.remove('modal-open')
		document.body.style.overflow = null
		document.body.style.paddingRight = null
	}

	openModal() {
		const modal = this.getModalInstance()
		modal.show()
	}

	closeModal(event) {
		const modal = this.getModalInstance()
		modal.hide()
	}

	getModalInstance() {
		return bootstrap.Modal.getOrCreateInstance(this.getElement())
	}

	getElement() {
		if (this.hasTurboModalTarget) {
			return this.turboModalTarget 
		} else { 
			return this.element
		}
	}

}
